import { usePathname } from 'next/navigation';
import QuestionnaireModal from 'components/Contact/questionnaire';
import { Box } from '@mui/material';
import React from 'react';
import Header from './Header';
import Search from './Search';

export default function UserDealNavbar({
    siteConfig,
    initialSearch,
    userType,
    setTotalCount,
    setDeals,
    setPage,
    setResultType,
    categories,
    fetchDeals,
    setInputValue
}) {
    const pathname = usePathname();

    return (
        <Box sx={{ flexGrow: 1, bgcolor: '#ffffff' }}>
            <Header siteConfig={siteConfig} userType={userType} />
             {/*Search Container*/}
            {pathname !== '/deals/creator/revenue' && (
                <Search
                    initialSearch={initialSearch}
                    setTotalCount={setTotalCount}   // part of reset function
                    setDeals={setDeals}             // set searched deals
                    setPage={setPage}               // part of reset function
                    setResultType={setResultType}   // part of reset function
                    categories={categories}         // categories for dropdown
                    fetchDeals={fetchDeals}         // function to fetch deals by category
                    setParentInputValue={setInputValue} // function to update parent's search term
                />
            )}
        </Box>
    );
}
